import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Register service worker
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('תוכן חדש זמין! לחץ אישור כדי לרענן.')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('האפליקציה מוכנה לעבודה במצב לא מקוון');
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
